module.exports = __webpack_public_path__ + "static/media/f1-tu1.46402ec9.jpg";